import styled from 'styled-components';

export const VideoContainer = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;
  margin: 2rem auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  max-width: 800px;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: inherit;
  }
`;

